module.exports = __webpack_public_path__ + "img/TSN_phone_03.ca783656.png";